// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".link--_CKp7 {\n  color: #fff !important;\n  text-decoration: none;\n}\n.link--_CKp7:hover {\n  text-decoration: underline;\n}", "",{"version":3,"sources":["webpack://./src/gui/Apps/Admin/Pages/InstantDealsWon/Breadcrumb.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B","sourcesContent":[".link {\n  color: #fff !important;\n  text-decoration: none;\n}\n.link:hover {\n  text-decoration: underline;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"link": "link--_CKp7"
};
export default ___CSS_LOADER_EXPORT___;
